module.exports = __webpack_public_path__ + "img/wolf_sketch.88286ffe.jpeg";